import types from './types';
import {fetchElementsPaginated, fetchElement, submitElement, deleteElement} from './common';

const apiUrl = '/api/pages';

export function submitPage(values) {
    return submitElement(apiUrl, values, types.SUBMIT_PAGE);
}
export function fetchPage(itemId) {
    return fetchElement(apiUrl, itemId, types.LOAD_PAGE);
}

export function fetchPagesPaginated(page = 0, size = 10) {
    return fetchElementsPaginated(`${apiUrl}/paginated`, page, size, types.LOAD_PAGES_PAGINATED);
}
export function fetchPageBySlug(slug) {
    return fetchElement(`${apiUrl}/slug`, slug, types.LOAD_PAGE);

}

export function deletePage(page) {
    return deleteElement(apiUrl, page.id, types.DELETE_PAGE);
}



// WEBPACK FOOTER //
// ./src/js/actions/page.js